import { _enum, schema } from "@anna-money/anna-web-lib/serializer";

export enum UserCluster {
  Control = 0, // No experiement
  Cluster1 = 1,
  Cluster2 = 2,
  Cluster3 = 3,
  Cluster4 = 4,
  // Cluster5 was used by MonthlyPlansExperiment and should not be used anymore
  Cluster5 = 5,
  // Cluster6, Cluster7 were used by BusinessLaunchExperiment and should not be used anymore
  Cluster6 = 6,
  Cluster7 = 7,
  // Cluster8 was used by CHFeeExperiment and should not be used anymore
  Cluster8 = 8,
  // Cluster9 was used by CashbackExperiment and should not be used anymore
  Cluster9 = 9,
  // Cluster10 was used by JustRegisterExperiment and should not be used anymore
  Cluster10 = 10,
  // Cluster11 is used by ChargeWhenNoAccountExperiment (£100 fee when no business account is opened)
  Cluster11 = 11,
}

export class UserClusterData extends schema(
  {
    clusterNum: _enum(UserCluster, "UserCluster"),
  },
  "UserClusterData",
) {}
